<section class="top-15 container fixed z-50">
  <div class="ml-2 mr-2">
    @for(notificationMessage of notificationMessages; track
    notificationMessage.id) {

    <div
      [@fadeInOut]
      class="mt-2 grid min-h-[2rem] grid-cols-[min-content_1fr_min-content] rounded-md p-2 shadow-lg"
      [ngClass]="{
    'bg-info': notificationMessage.severity === Severity.INFO,
    'bg-warning': notificationMessage.severity === Severity.WARNING,
    'bg-error': notificationMessage.severity === Severity.ERROR
    }"
      [attr.data-testid]="notificationMessageTestId"
    >
      <div class="mr-5 flex items-center">
        <pax-icon
          [name]="getIconName(notificationMessage.severity)"
          containerClass="w-5 h-5"
        ></pax-icon>
      </div>

      <div class="mr-5 flex-1 break-all">
        @if(notificationMessage.text){
        <span>{{ notificationMessage.text }} </span>
        } @if(notificationMessage.markdown){
        <pax-markdown>{{ notificationMessage.markdown }}</pax-markdown>
        }
      </div>

      <button
        i18n-aria-label
        aria-label="Benachrichtigung löschen"
        class="cursor-pointer"
        (click)="deleteNotificationMessage(notificationMessage.id)"
      >
        <pax-icon [name]="iconClose.name"></pax-icon>
      </button>
    </div>

    }
  </div>
</section>
